import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_bf_icons_v4",
  stages: {
    main: 1,
    ddot: 2,
    mdot: 3,
    sees_exclusion: 4,
    sees_sellable: 5,
    upsell_prompt: 6
  },
  goals: {},
  defaultStage: 1
});

const trackStages = (isMobile: boolean, hasExcludedFeature: boolean, hasSellableFeature: boolean) => {
  utils.stages.main();
  isMobile ? utils.stages.mdot() : utils.stages.ddot();
  if (hasExcludedFeature) utils.stages.sees_exclusion();
  if (hasSellableFeature) utils.stages.sees_sellable();
};

export default { trackStages, ...utils };
